import {
  useEffect,
  useState
} from "react";

import API from "../../services/api";
import toast from "react-hot-toast";

function AdminProfile() {

  const [form,
    setForm] =
    useState({
      name: "",
      email: ""
    });

  const [image,
    setImage] =
    useState(null);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile =
    async () => {

      const token =
        localStorage.getItem(
          "adminToken"
        );

      const res =
        await API.get(
          "/admin/profile",
          {
            headers:{
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      setForm(res.data);
    };

  const save =
    async (e) => {

      e.preventDefault();

      const token =
        localStorage.getItem(
          "adminToken"
        );

      const data =
        new FormData();

      data.append(
        "name",
        form.name
      );

      data.append(
        "email",
        form.email
      );

      if(image){
        data.append(
          "profile_image",
          image
        );
      }

      await API.put(
        "/admin/profile",
        data,
        {
          headers:{
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      toast.success(
        "Profile Updated"
      );
    };

  return (
    <div
      className="
      max-w-xl
      "
    >
      <h1
        className="
        text-3xl
        font-bold
        mb-6
        "
      >
        Admin Profile
      </h1>

      <form
        onSubmit={save}
        className="
        bg-[#111]
        p-6
        rounded-2xl
        space-y-4
        "
      >

        <input
          value={form.name}
          onChange={(e)=>
            setForm({
              ...form,
              name:
                e.target.value
            })
          }
          placeholder="Name"
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          "
        />

        <input
          value={form.email}
          onChange={(e)=>
            setForm({
              ...form,
              email:
                e.target.value
            })
          }
          placeholder="Email"
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          "
        />

        <input
          type="file"
          onChange={(e)=>
            setImage(
              e.target.files[0]
            )
          }
        />

        <button
          className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          "
        >
          Save Profile
        </button>

      </form>
    </div>
  );
}

export default AdminProfile;